import React, { useContext } from "react";
import { Field, ErrorMessage } from "formik";
import { Typography, Box } from "@mui/material";
import Select from "react-select";
import NewCaseField from "./Fields/NewCaseField";

import NewCaseSelect from "./Fields/NewCaseSelect";
import FormError from "../../components/FormError";
import FMUTextField from "../../components/shared/FormIkMUFormComponent/FMUTextField";
import { viewportContext } from "../../context/ViewportContext";
import { useCaseStyles } from "./useCaseStyle";
import { reactSelectStyles } from "./reactSelectStyles";
import { CASE_TYPES } from "../../utils/constants";
import { states } from "../shared/helpers/states";
import { CaseDetailsTabProps } from "../../types/NewCaseView/CaseDetailsTabTypes";
import DuplicateWarning, { DuplicateChecking } from "./DuplicateWarning";
import { useDuplicateCheck } from "../../hooks/NewCaseView/useDuplicateCheck";

const CaseDetailsTab = ({
  values,
  setFieldValue,
  handleDateRefferedChange,
}: CaseDetailsTabProps) => {
  const { tallScreen } = useContext(viewportContext) as {
    tallScreen?: boolean;
  };
  const classes = useCaseStyles();
  const addressCheck = useDuplicateCheck(
    "property_address",
    values?.case_details?.case_information?.subject_property_address?.street_address
  );

  return (
    <>
      <div className={classes.columns}>
        <div className={classes.column}>
          <div className={classes.parent}>
            <NewCaseSelect
              label={"Case type"}
              type={"text"}
              name={"case_details.case_information.case_type"}
              options={CASE_TYPES}
              required={true}
            />
          </div>
          <div className={classes.parent}>
            <NewCaseField
              label={"Budget"}
              type={"number"}
              name={"case_details.budget_information.scheduled"}
            />
          </div>
          <div className={classes.parent}>
            <NewCaseField
              label={"Sale date"}
              type={"date"}
              name={"case_details.case_information.sale_date"}
            />
          </div>
          <div className={classes.parent}>
            <NewCaseField
              label={"Follow up"}
              type={"date"}
              name={"case_details.case_information.follow_up"}
            />
          </div>
          <div className={classes.parent}>
            <NewCaseField
              label={"Date referred"}
              type={"date"}
              name={"case_details.case_information.date_referred"}
              required={true}
              input={true}
              customOnChange={handleDateRefferedChange}
            />
          </div>
          <div className={classes.parent}>
            <NewCaseField
              label={"Reopened date"}
              type={"date"}
              name={"case_details.client_information.reopened_date"}
            />
          </div>
        </div>

        <div className={classes.column}>
          <div className={classes.parent}>
            <NewCaseField
              label={"Due date"}
              type={"date"}
              name={"case_details.case_information.due_date"}
            />
          </div>
          <div className={classes.parent}>
            {/* <NewCaseSelect label={"Client name"} type={"text"} name={"case_details.client_information.client"} options={clientNames}/> */}
            <NewCaseField
              label={"Property Address Street"}
              type={"text"}
              name={`case_details.case_information.subject_property_address.street_address`}
              labelAdornment={<DuplicateChecking active={addressCheck.checking} />}
            />
          </div>
          <DuplicateWarning matches={addressCheck.matches} label="property address" />

          <div className={classes.parent}>
            {/* <NewCaseSelect label={"Client name"} type={"text"} name={"case_details.client_information.client"} options={clientNames}/> */}
            <NewCaseField
              label={"Property Address City"}
              type={"text"}
              name={`case_details.case_information.subject_property_address.city`}
            />
          </div>
          <div className={classes.parent}>
            <div
              className={
                tallScreen ? classes.parentChildTallScreen : classes.parentChild
              }
            >
              <div className={classes.rowContainer}>
                <div className={classes.labelContainer}>
                  <Typography>Property Address State</Typography>
                </div>
                <div className={classes.fieldContainer}>
                  <Select
                    styles={reactSelectStyles}
                    placeholder={"Property Address "}
                    value={{
                      label:
                        values?.case_details?.case_information
                          .subject_property_address.state,
                    }}
                    onChange={(e: any) => {
                      setFieldValue(
                        `case_details.case_information.subject_property_address.state`,
                        e.value
                      );
                    }}
                    options={states}
                  />
                  {/* <ErrorMessage  name={`case_details.case_information.subject_property_address.state`}>
                              { msg => <div className={classes.error}>{msg}</div> }
                        </ErrorMessage> */}
                </div>
              </div>
              <ErrorMessage
                name={`case_details.case_information.subject_property_address.state`}
                component={FormError}
                className={classes.error}
              />
            </div>
          </div>
          <div className={classes.parent}>
            <NewCaseField
              label={"Property Address Zip-code"}
              type={"text"}
              name={`case_details.case_information.subject_property_address.zip_code`}
            />
          </div>
        </div>
      </div>

      <div className={classes.parent} style={{ height: "auto" }}>
        <div
          className={
            tallScreen ? classes.parentChildTallScreen : classes.parentChild
          }
          style={{ height: "auto" }}
        >
          <div className={classes.rowContainer}>
            <div className={classes.labelContainer}>
              <Typography>Referral Note</Typography>
            </div>
            <div className={classes.fieldContainer}>
              <Field
                name={"case_details.case_information.referral_notes"}
                type={"text"}
                fullwidth={"true"}
                disableUnderline={true}
                multiline={true}
                className={classes.textField}
                component={FMUTextField}
                style={{
                  width: "99%",
                  height: "230px",
                  overflowY: "scroll",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CaseDetailsTab;
